import React, { useEffect, useRef } from 'react';
import "../../styles/notification.scss";
import { useNotification } from '../../context/notificationContext';
import { X } from "lucide-react"; // Lucide close icon

const NotificationPrompt = () => {
    const [notification, visible, , hideNotification] = useNotification();
    const timerRef = useRef(null);

    const startTimer = () => {
        timerRef.current = setTimeout(() => {
            hideNotification();
        }, 7000);
    };

    useEffect(() => {
        startTimer();
        return () => {
            clearTimeout(timerRef.current);
        };
    }, [notification]);

    const handleMouseEnter = () => {
        clearTimeout(timerRef.current);
    };

    const handleMouseLeave = () => {
        startTimer();
    };

    return (
        <div
            className={`notification ${notification?.type} ${visible ? 'visible' : ''}`}
            onMouseOver={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <p>{notification?.message}</p>
            <span onClick={hideNotification} className="close-btn">
                <X size={18} strokeWidth={2} /> {/* Lucide X icon */}
            </span>
        </div>
    );
};

export default NotificationPrompt;
